module.exports = __webpack_public_path__ + "img/1102456465.01a68761.jpg";